

import SourceItem from './SourceItem'
import TargetItem from './TargetItem';

class ConnectLine {

    constructor() {
        this.lineId = 0;
        this.lineIndex = 0;
        this.sourceItem = new SourceItem()
        this.targetItem = new TargetItem()
        this.lineHtml = null //html drawn line
    }


    getReviewColor = () => {

        let color = "green"
        let result = false
        this.targetItem.sourceItemList.forEach((solvedSource, index) => {

            if (solvedSource.sourceIndex == this.sourceItem.sourceIndex) {
                result = true
            }
        })

        if (!result)
                color = "red"
        return color
    }


    refershLine = () => {
        return this.connect(
            this.sourceItem.htmlRef,
            this.targetItem.htmlRef,
            "red",
            2,
            0,
            "solid",
            "red"
        )
    }

    createHtml = () => {

        this.lineHtml = this.connect(
            this.sourceItem.htmlRef,
            this.targetItem.htmlRef,
            "red",
            2,
            0,
            "solid",
            "red"
        )
    }


    connect = (div1, div2, color, thickness, q_num, borderType, borderColor) => { // draw a line connecting elements
        var off1 = this.getOffset(div1);
        var off2 = this.getOffset(div2);

        // bottom right
        var x1 = off1.left // / factor;
        var y1 = (off1.top + off1.height / 2) /// factor;

        // top right
        var x2 = (off2.left + off2.width) // / factor;
        var y2 = (off2.top + off2.height / 2) // / factor;

        // distance
        var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
        // center
        var cx = (((x1 + x2) / 2) - (length / 2));
        var cy = (((y1 + y2) / 2) - (thickness / 2));
        // angle
        var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);

        var d = document.createElement("div");
        d.setAttribute("class", "connect_line");
        //d.setAttribute("id", "line_" + q_num);
        d.setAttribute("style", "padding:0px; margin:0px;border:2px " + borderColor + " " + borderType + "; height:" + thickness + "px; background-color:" + color + "; line-height:1px; position:absolute; left:" + cx + "px; top:" + cy + "px; width:" + length + "px; -moz-transform:rotate(" + angle + "deg); -webkit-transform:rotate(" + angle + "deg); -o-transform:rotate(" + angle + "deg); -ms-transform:rotate(" + angle + "deg); transform:rotate(" + angle + "deg);");
        document.body.appendChild(d);

        //linesArr.push(d);
        return d
    }

    getOffset = (el) => {
        //     var rect = el.getBoundingClientRect();
        //     return {
        //         left: rect.left,
        //         top: rect.top,
        //         width: rect.width,
        //         height: rect.height
        //     };


        // var rect = el.getBoundingClientRect();
        return {
            left: el.offsetLeft,
            top: el.offsetTop,
            width: el.offsetWidth,
            height: el.height
        };

    }

}
export default ConnectLine